import React, { Fragment } from 'react';
import VerticalStack from '../components/VerticalStack';

import { Abstract, Logo } from '../components/Section';

import Header from '../components/Header';
import { Slideshow } from '../components/slideshow/Slideshow';
import { Paragraph } from '../components/typography';
import styled from 'styled-components';
import responsive from '../utils/responsive';
import { Collage, Image } from './HomePage';
import sampleSize from 'lodash-es/sampleSize';
import { NotFound } from '../App';
import withHelmet from '../utils/withHelmet';

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  padding: 5em 5em;
  margin: auto;

  align-items: center;
  white-space: normal;
  text-align: justify;

  > h2 {
    text-align: center;
  }

  > h5 {
    text-align: center;
  }

  > p {
    padding: 2em;
  }

  background: white;

  ${responsive.md.andSmaller`
    padding: 0;
  `};
`;

const areas = ['a', 'b', 'c', 'd'];

const RestaurantPage = ({ id, content }) => {
  const restaurant = content.restaurant(id);
  if (!restaurant) {
    return <NotFound />;
  }

  return (
    <VerticalStack>
      <div>
        <Slideshow
          images={restaurant.gallery}
          style={{ height: '100vh', width: '100vw' }}
        >
          <Header
            LogoComponent={
              <Logo
                style={{
                  width: '17em',
                  height: '11em',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain',
                  backgroundColor: restaurant.color,
                  pointerEvents: 'all',
                }}
                src={restaurant.logoMain || restaurant.logo}
                to={'/#dining'}
              />
            }
            title={restaurant.title}
            subtitle={restaurant.subtitle}
            style={{ zIndex: 20, position: 'absolute', top: 0, left: 0 }}
          />
        </Slideshow>
        <Content className={'restaurant-content'}>
          <Abstract>{restaurant.abstract}</Abstract>
          <Logo src={restaurant.logo} to={'/#dining'} />
          <Paragraph>{restaurant.about}</Paragraph>
        </Content>
        <Collage>
          {sampleSize(restaurant.gallery, 4).map((img, i) => (
            <Image key={i} src={img} style={{ gridArea: areas[i] }} />
          ))}
        </Collage>
      </div>
      <Fragment />
    </VerticalStack>
  );
};

export default withHelmet('restaurant')(RestaurantPage);
